// hosts.ts and accounts.ts are deliberately not present here (FNP-1119).
//
// hosts.ts: in console it exports one stage-selected `{url}` for console's own
// origin. That data already lives here as `platform.email` in platform.ts, which
// carries every property's URL per stage. A hosts.ts would be a second source of
// truth for the same string. Note console's own hosts.ts has zero importers.
//
// accounts.ts: in console it exists solely so BaseService.isDefaultAccount() can
// decide whether to take the cross-account STS AssumeRole path. This app's
// BaseService (src/services/BaseService.ts) is single-account — no STSClient, no
// AssumeRoleCommand, no account list to consult. The file would have no reader.
//
// Add either one when a real consumer appears, not to match the reference layout.
import platform from "./platform";
import {stage} from './stage';
import kinesis from './kinesis.js';
import permissions from "./permissions.ts";


const config = {
    platform,
    stage,
    kinesis,
    appTitle: "Flexi eMail",
    appSubTitle: "Flexi eMail",
    appLogoUrl: "/250x50_logo.png",
    permissions
};

export default config;
